import dayjs from 'dayjs';

const currentYear = new Date().getFullYear();
const yearPresets: Record<number, string> = {};
for (let year = 2019; year < currentYear; year += 1) {
  yearPresets[year] = year.toString();
}

export const DateRangePresets: Record<string | number, string> = {
  ONE_DAY: '1d',
  ONE_WEEK: '7d',
  TWO_WEEKS: '14d',
  ONE_MONTH: '1m',
  THREE_MONTHS: '3m',
  SIX_MONTHS: '6m',
  TWELVE_MONTHS: '12m',
  THIS_YEAR: 'this_year',
  ...yearPresets,
};

export const SetDateIntervalStrings = Object.values(DateRangePresets);

export const DateRangeMutators = {
  [DateRangePresets.ONE_DAY]: () => [dayjs().subtract(1, 'day'), dayjs()],
  [DateRangePresets.ONE_WEEK]: () => [dayjs().subtract(1, 'week'), dayjs()],
  [DateRangePresets.TWO_WEEKS]: () => [dayjs().subtract(2, 'weeks'), dayjs()],
  [DateRangePresets.ONE_MONTH]: () => [dayjs().subtract(1, 'month'), dayjs()],
  [DateRangePresets.THREE_MONTHS]: () => [
    dayjs().subtract(3, 'months'),
    dayjs(),
  ],
  [DateRangePresets.SIX_MONTHS]: () => [dayjs().subtract(6, 'months'), dayjs()],
  [DateRangePresets.TWELVE_MONTHS]: () => [
    dayjs().subtract(12, 'months'),
    dayjs(),
  ],
  [DateRangePresets.THIS_YEAR]: () => [
    dayjs(new Date(new Date().getFullYear(), 0, 1)),
    dayjs(),
  ],
};

for (let year = 2019; year < currentYear; year += 1) {
  DateRangeMutators[DateRangePresets[year]] = () => [
    dayjs(new Date(year, 0, 1)),
    dayjs(new Date(year, 11, 31)),
  ];
}
